import type { ReactNode } from 'react';

/** Editorial section heading: eyebrow + serif title + optional lede/action. */
export function SectionHeader({
  eyebrow,
  title,
  lede,
  action,
  as = 'h2',
}: {
  eyebrow?: string;
  title: string;
  lede?: string;
  action?: ReactNode;
  as?: 'h1' | 'h2';
}) {
  const Title = as;
  return (
    <header
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        gap: 'var(--space-4)',
        marginBottom: 'var(--space-6)',
      }}
    >
      <div>
        {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        <Title className="section-title">{title}</Title>
        {lede ? <p className="lede" style={{ marginTop: 'var(--space-3)' }}>{lede}</p> : null}
      </div>
      {action ? <div>{action}</div> : null}
    </header>
  );
}
